import React from "react";
import { receiptCents } from "./receiptHistoryContract";
import { formatFinancialMoney } from "./financialPresentation";
export default function OpenAmountBreakdown({ summary }) {
  const pending = receiptCents(summary.pendingAmount), overdue = receiptCents(summary.overdueAmount), total = receiptCents(summary.openAmount);
  if ([pending, overdue, total].some(value => value === null) || !Number.isSafeInteger(pending + overdue) || pending + overdue !== total) {
    return <small>Detalhamento indisponível. Atualize para conferir a composição.</small>;
  }
  return <div aria-label="Composição do valor em aberto">
    <small>Por situação no Asaas:</small>
    <small>Pendentes: {formatFinancialMoney(summary.pendingAmount)}</small>
    <small>Vencidas: {formatFinancialMoney(summary.overdueAmount)}</small>
    <small>“Pendente” pode incluir vencimentos passados. Confira a análise por data no Painel financeiro.</small>
  </div>;
}
